import { useMetaTags } from '../../shared/hooks/useMetaTags';
import { useLanguage } from '../../shared/hooks/useLanguage';
import { TERMS_OF_SERVICE_CONTENT } from '../../shared/config/constants';
import './LegalPage.css';

/**
 * 利用規約ページコンポーネント
 */
function TermsOfService() {
  const lang = useLanguage();
  const content = TERMS_OF_SERVICE_CONTENT[lang];

  // メタタグを設定
  useMetaTags({
    title: lang === 'ja' ? '利用規約 | ブログ' : 'Terms of Service | Blog',
    description: lang === 'ja'
      ? '当サイトの利用規約について説明します。'
      : 'This page explains the terms of service of this site.',
  });

  const renderContent = (section: typeof content.sections[0]) => {
    const contentArray = Array.isArray(section.content) ? section.content : [section.content];
    
    return (
      <>
        {contentArray.map((paragraph, index) => (
          <p key={index} dangerouslySetInnerHTML={{ __html: paragraph }} />
        ))}
        {section.items && (
          <ul>
            {section.items.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        )}
      </>
    );
  };

  return (
    <div className="legal-page">
      <div className="legal-page__container">
        <h1 className="legal-page__title">{content.title}</h1>
        <div className="legal-page__content">
          <p className="legal-page__last-updated">{content.lastUpdated}</p>

          {content.sections.map((section, index) => (
            <section key={index} className="legal-page__section">
              {section.heading && (
                <h2 className="legal-page__heading">{section.heading}</h2>
              )}
              {section.subheading && (
                <h3 className="legal-page__subheading">{section.subheading}</h3>
              )}
              {renderContent(section)}
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}

export default TermsOfService;

